import CalendarModel from "@/models/calendar/calendarModel";
import CalendarUpsertModel from "@/models/calendar/calendarUpsertModel";
import { apiClient } from "./apiService";
import { AxiosResponse } from "axios";

export default {
  async getAllCalendarsAsync(): Promise<Array<CalendarModel>> {
    const response = await apiClient.get("calendar");
    return response.data.map((x: AxiosResponse) => new CalendarModel(x));
  },
  async getAllCalendarsByUserAsync(
    userId: string
  ): Promise<Array<CalendarModel>> {
    const response = await apiClient.get(`calendar/user/${userId}`);
    return response.data.map((x: AxiosResponse) => new CalendarModel(x));
  },
  async getCalendarAsync(calendarId: string): Promise<CalendarModel> {
    const response = await apiClient.get(`calendar/${calendarId}`);
    return new CalendarModel(response.data);
  },
  async createCalendar(model: CalendarUpsertModel): Promise<CalendarModel> {
    const response = await apiClient.post(`calendar`, model);
    return new CalendarModel(response.data);
  },
  async updateCalendar(
    calendarId: string,
    model: CalendarUpsertModel
  ): Promise<CalendarModel> {
    const response = await apiClient.put(`calendar/${calendarId}`, model);
    return new CalendarModel(response.data);
  },
  async deleteCalendar(calendarId: string): Promise<void> {
    await apiClient.delete(`calendar/${calendarId}`);
  }
};
